import React, { useContext } from 'react';
import styled from 'styled-components';
import Clipboard from 'react-clipboard.js';

import i18n from '../i18n';
import { showSuccess } from '../services/toastService';
import Icon from './Icon';
import ThemeContext from '../contexts/ThemeContext';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const CopyButton = styled(Clipboard)`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

const OrderNumberCell = ({ value }) => {
  const { colors } = useContext(ThemeContext);

  if (!value) {
    return null;
  }

  return (
    <Container>
      <span>{value}</span>
      <CopyButton
        data-clipboard-text={value}
        button-title={i18n('copy_reservation')}
        onSuccess={() => showSuccess(i18n('copied_to_clipboard'))}
      >
        <Icon
          icon="content_copy"
          iconLib="material"
          iconColor={colors.webDarkBlue}
          iconSize={16}
          withoutContainer
        />
      </CopyButton>
    </Container>
  );
};

export default OrderNumberCell;
